module.exports = __webpack_public_path__ + "static/img/caiBG.02f93a4a.png";